module.exports = __webpack_public_path__ + "static/media/bpjs_ketenagakerjaan.1711b435.png";